import { createBrowserRouter } from "react-router";
import { Layout } from "./components/layout";
import { Today } from "./screens/today";
import { Appointments } from "./screens/appointments";
import { AppointmentDetails } from "./screens/appointment-details";
import { AppointmentView } from "./screens/appointment-view";
import { AppointmentForm } from "./screens/appointment-form";
import { AppointmentWizard } from "./screens/appointment-wizard";
import { CustomerHistory } from "./screens/customer-history";
import { ClientDNA } from "./screens/client-dna";
import { Insights } from "./screens/insights";
import { Notifications } from "./screens/notifications";
import { Settings } from "./screens/settings";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    children: [
      { index: true, Component: Today },
      { path: "appointments", Component: Appointments },
      { path: "appointment/new", Component: AppointmentWizard },
      { path: "appointment-view/:id", Component: AppointmentView },
      { path: "appointment/:id", Component: AppointmentDetails },
      { path: "appointment/:id/edit", Component: AppointmentForm },
      { path: "customer/:customerId/history", Component: CustomerHistory },
      { path: "client-dna/:customerId", Component: ClientDNA },
      { path: "insights", Component: Insights },
      { path: "notifications", Component: Notifications },
      { path: "settings", Component: Settings },
    ],
  },
]);